import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Coins } from "lucide-react";
import { toast } from "sonner";

export const CoinFlip = () => {
  const [result, setResult] = useState<"Heads" | "Tails" | null>(null);
  const [isFlipping, setIsFlipping] = useState(false);

  const flipCoin = () => {
    setIsFlipping(true);
    
    setTimeout(() => {
      const array = new Uint32Array(1);
      crypto.getRandomValues(array);
      const flip = array[0] % 2 === 0 ? "Heads" : "Tails";
      setResult(flip);
      setIsFlipping(false);
      toast.success(`It's ${flip}!`);
    }, 500);
  };

  return (
    <Card className="p-6 shadow-[var(--shadow-medium)]">
      <div className="flex items-center gap-2 mb-6">
        <Coins className="w-6 h-6 text-primary" />
        <h2 className="text-2xl font-bold text-foreground">Coin Flip</h2>
      </div>

      <Button onClick={flipCoin} className="w-full mb-4 h-12 text-lg touch-manipulation" disabled={isFlipping}>
        Flip Coin
      </Button>

      {result && (
        <div className="bg-gradient-to-br from-primary to-primary/80 rounded-lg p-12 text-center">
          <div className={`text-5xl font-bold text-primary-foreground transition-transform ${isFlipping ? 'rotate-180 scale-110' : 'rotate-0 scale-100'}`}>
            {result}
          </div>
        </div>
      )}
    </Card>
  );
};
